import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { logger } from "../utils/logger";

export const useLogout = (): (() => Promise<void>) => {
    const navigate = useNavigate();
    const { logout: closeSession } = useAuth();

    const logout = async (): Promise<void> => {
        try {
            // Тела у запроса нет: сессию сервер находит по cookie hawk.sid.
            await closeSession();
        } catch (error) {
            logger.error("Logout error:", error);
        } finally {
            navigate("/login", { replace: true });
        }
    };

    return logout;
};
